__turbopack_context__.v({
  "bodyCopyWrapper": "Card-module-scss-module__ONqoaa__bodyCopyWrapper",
  "card": "Card-module-scss-module__ONqoaa__card",
  "close": "Card-module-scss-module__ONqoaa__close",
  "closeButton": "Card-module-scss-module__ONqoaa__closeButton",
  "closeIconBuffer": "Card-module-scss-module__ONqoaa__closeIconBuffer",
  "closeIconWrapper": "Card-module-scss-module__ONqoaa__closeIconWrapper",
  "fade-in": "Card-module-scss-module__ONqoaa__fade-in",
  "headlineWrapper": "Card-module-scss-module__ONqoaa__headlineWrapper",
  "icon": "Card-module-scss-module__ONqoaa__icon",
  "isClosing": "Card-module-scss-module__ONqoaa__isClosing",
  "root": "Card-module-scss-module__ONqoaa__root",
  "scale": "Card-module-scss-module__ONqoaa__scale",
  "scale-mobile": "Card-module-scss-module__ONqoaa__scale-mobile",
});
